import React, {useCallback} from 'react';
import isNil from 'lodash/isNil';
import {CheckmarkIcon} from '~library/svg/CheckmarkIcon';
import {emeraldWebText} from '~libSass/base/_exports.sass';

import './FontItem.sass';

export const FontItem = ({font, selected, onClick}) => {
  if (isNil(font)) {
    return null;
  }

  const onClickHandler = useCallback(() => onClick(font), [font]);

  return (
    <div className="font_item" onClick={onClickHandler} role="button">
      <p
        key={`${font.name}-${font.weight}-${font.style}`}
        className={selected ? 'paragraph--selected' : ''}
        style={{
          fontFamily: font?.family,
          fontWeight: font?.weight ?? 'normal',
          fontStyle: font?.style ?? 'normal',
        }}
      >
        {font.name}
      </p>
      {!!selected && <CheckmarkIcon ratio={0.5} color={emeraldWebText} />}
    </div>
  );
};
